#import "./automation-conditions-fragment.graphql"

fragment StageLeadUserAssignmentData on Stage {
    editableStageLeadAssignmentAutomationData {
        stageLeadAssignmentAllowReassign
        stageLeadAssignmentDefaultAutomation {
            ...StageLeadAssignmentAutomation
        }
        stageLeadAssignmentAutomations {
            ...StageLeadAssignmentAutomation
        }
    }
}

fragment StageLeadAssignmentAutomation on StageLeadAssignmentAutomation {
    shouldUnassign
    shouldRoundRobin
    assignee {
        id
        name
        ... on User {
            isEnabled
        }
        ... on Team {
            deletedTime
        }
    }
    predicate {
        conditions {
            ...Condition
        }
    }
}
